import React from "react";
import { Col, Row, Card, CardBody } from "reactstrap";

import withRouter from "../../Components/Common/withRouter";

const PrivacyPolicy = () => {
  document.title = "Politique de confidentialité | Business Online";
  return (
    <React.Fragment>
        <Row className="g-0 auth-container">
          <Col lg={12} xs={12}>
            <div className="faq-bloc">
              <div>
                <h2>Politique de confidentialité</h2>
              </div>
              <div className="mt-4">
                <Card>
                  <CardBody>
                    <p>
                      BANK OF AFRICA et le Client considèrent comme strictement
                      confidentielles toutes les informations et/ou requêtes
                      transitant par la Plate-forme technique mise en place dans
                      le cadre des services Business Online.
                    </p>
                    <p>
                      Ces informations et/ou requêtes ne pourront être utilisées
                      à d’autres fins que celles prévues par BANK OF AFRICA et
                      le Client au titre de la souscription au service.
                    </p>
                    <p>
                      Toutefois, ces informations et/ou requêtes sont réputées
                      ne pas contenir d’informations confidentielles dès lors
                      qu’elles appartiennent au domaine public, sauf si elles
                      sont divulguées sans autorisation à un tiers par l’une ou
                      l’autre des parties.
                    </p>
                    <p>
                      Etant expressément entendu que si BANK OF AFRICA s’adresse
                      à un tiers pour la réalisation de tout ou partie de ses
                      obligations, elle veillera à faire respecter par ledit
                      tiers la stricte confidentialité des informations et/ou
                      requêtes dont il aura connaissance.
                    </p>
                    <p>
                      Pour protéger le caractère confidentiel de ses données
                      financières, le Client est invité à prendre les
                      dispositions adéquates pour prévenir la mémorisation des
                      données consultées ou pour procéder à l’effacement de
                      celles-ci une fois la consultation terminée. Il demeure
                      seul responsable de la protection de ses données.
                    </p>
                    <p>
                      Si BANK OF AFRICA suspecte une contamination des messages
                      reçus du souscripteur, elle se réserve le droit de
                      suspendre l’accès à la Plate-forme technique mise en place
                      dans le cadre des services Business Online et aux Services
                      et d’en aviser le Client sans délais, ce à quoi il
                      autorise d’ores et déjà.
                    </p>
                    <p>
                      Le Client s’engage à faire respecter cette obligation de
                      confidentialité par toute personne habilitée utilisatrice
                      du service Business Online.
                    </p>
                  </CardBody>
                </Card>
              </div>
            </div>
          </Col>
        </Row>
    </React.Fragment>
  );
};

export default withRouter(PrivacyPolicy);
